module.exports = __webpack_public_path__ + "img/Bank_Markazi.23d6a503.svg";